'use client';

import { createAuthenticatedRequest } from '@/shared/api/api-client';
import { useSession } from '@/shared/hooks/use-session';

export const useApi = () => {
  const { token } = useSession();

  return createAuthenticatedRequest(token);
};
